const INITIAL_STATE = {
  playerLibraryLocation: undefined,
  playerLicense: undefined,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'PLAYBACK_LICENSE_CHANGE':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
